export default {
  title: 'Healthcare Professionals Directory',
  subtitle: 'List of specified professionals',
  search: 'Search professional',
  personnalInformations: 'Personnal informations',
  professionalInfoDisplay: {
    title: 'Professional Informations',
    generalInformations: 'General Informations',
    professionnalInformations: 'Professional Informations',
    job: 'Profession',
    expertise: 'Expertise',
    speciality: 'Specialty',
    establishment: 'Establishment',
    coordinates: 'Coordinates',
    phone: 'Phone',
    mail: 'Email',
    location: 'Address',
    contact: 'Contact'
  },
  columns: {
    professional: 'Professional',
    skills: 'Skills',
    contact: 'Contact',
    actions: 'Actions'
  },
  close: {
    filters: 'Close filters',
    search: 'Close search'
  },
  filters: {
    job: 'Profession',
    skills: 'Skills'
  },
  referent: 'Referent',
  proReferent: 'Referring professional',
  professionalList: {
    noEntry: 'No professionals found.',
    noSpecialty: 'No specialty',
    noProfession: 'No profession'
  },
  contact: {
    phone: 'Contact by phone',
    mail: 'Contact by mail'
  },
  errors: {
    fetchProfessionals: 'An error occurred while fetching professionals',
    fetchBySearch: 'An error occurred while fetching BY SEARCH',
    fetchBySkills: 'An error occurred while fetching BY SKILLS:',
    fetchByJob: 'An error occurred while fetching BY PROFESSION:',
    fetchSkills: 'An error occurred while fetching skills:'
  },
  professions: {
    dentalAssistant: 'Dental assistant',
    socialAssistant: 'Social assistant',
    audioProsthetist: 'Audio-prosthetist',
    chiropractor: 'Chiropractor',
    dentalSurgeon: 'Dental surgeon',
    dietician: 'Dietician',
    epithesist: 'Epithesist',
    ergotherapist: 'Ergotherapist',
    nurse: 'Nurse',
    ermManipulator: 'ERM manipulator',
    physiotherapist: 'Physiotherapist',
    doctor: 'Doctor',
    oculist: 'Oculist',
    optician: 'Optician',
    speechTherapist: 'Speech therapist',
    orthopaedist: 'Orthopaedist',
    orthoprosthetist: 'Orthoprosthetist',
    orthotist: 'Orthotist',
    osteopath: 'Osteopath',
    pharmacist: 'Pharmacist',
    medicalPhysist: 'Medical physist',
    podiatrist: 'Podiatrist',
    nonPS: 'Non PS profession',
    psychologist: 'Psychologist',
    psychomotrician: 'Psychomotrician',
    psychotherapist: 'Psychotherapist',
    chiropodist: 'Chiropodist',
    midwife: 'Midwife',
    laboratoryTechnician: 'Laboratory technician'
  }
}
